import{useEffect as e}from"react";function useScrollIntoView(o,t){return e(function(){o.items.length>0&&t.current&&t.current.scrollIntoView({behavior:"smooth",block:"end"})},[o]),t}export{useScrollIntoView as default};
//# sourceMappingURL=useScrollIntoView.js.map
